module.exports = __webpack_public_path__ + "51307bb4fad3d466c909a7ae2e2c8775.png";